import axiosInstance from '../../utils/axiosConfig';
import { getPersonsDetails, getPartyDetails } from "./party";
import { getClaimDetails } from "./claim";
import { getGoodsForPolicy } from "./policy";

// Une seule requête batch vers ms-party au lieu d'un GetPersonDetails par inspecteur
const attachPersonDetails = async (inspectors) => {
  const uids = [...new Set(inspectors.map((i) => i.associatedParty).filter(Boolean))];
  const persons = uids.length ? await getPersonsDetails(uids) : [];
  const personsByUid = Object.fromEntries(persons.map((p) => [p.uid, p]));
  return inspectors.map((inspector) => ({
    ...inspector,
    personDetails: personsByUid[inspector.associatedParty],
  }));
};
export const GET_ALLINSPECTOR = "GET_ALLINSPECTOR";
export const ADD_INSPECTOR_SHIFT_TIMESLOT = 'ADD_INSPECTOR_SHIFT_TIMESLOT';
export const GET_ALLINSPECTOR_SHIFT_TIMESLOT = "GET_ALLINSPECTOR_SHIFT_TIMESLOT";
export const GET_ALLINSPECTOR_SHIFT_TIMESLOT_ERROR = 'GET_ALLINSPECTOR_SHIFT_TIMESLOT_ERROR';
export const FILTER_INSPECTION_MISSIONS = "FILTER_INSPECTION_MISSIONS";
export const FILTER_INSPECTION_MISSIONS_ERROR = "FILTER_INSPECTION_MISSIONS_ERROR";
export const FILTER_INSPECTORS_REQUEST = 'FILTER_INSPECTORS_REQUEST';
export const FILTER_INSPECTORS_SUCCESS = 'FILTER_INSPECTORS_SUCCESS';
export const FILTER_INSPECTORS_FAILURE = 'FILTER_INSPECTORS_FAILURE';
export const FETCH_INSPECTORS_SUCCESS = 'FETCH_INSPECTORS_SUCCESS';
export const FETCH_INSPECTORS_FAILURE = 'FETCH_INSPECTORS_FAILURE';
export async function getClaimAssociatedMissions(claimNumber) {
  try {

    const url = `${process.env.REACT_APP_BACKEND_URL_MS_INSPECTION}/inspectionMission/getClaimAssociatedMissions/${claimNumber}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error(`Error fetching inspection Mission details: ${error.message}`);
  }
}


export function getAllInspector() {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.get(`${process.env.REACT_APP_BACKEND_URL_MS_INSPECTION}/inspector/getAll`);
      const inspectors = response.data;
      const inspectorsWithDetails = await attachPersonDetails(inspectors);
      dispatch({
        type: GET_ALLINSPECTOR,
        payload: inspectorsWithDetails,
      });
      return inspectorsWithDetails
    } catch (error) {
      console.log("error", error);
    }
  };
}

// in store/action/inspectionMission.js
// store/action/inspectionMission.js
export const getMissionsForClaim = ({ relatedClaimUid, claimNumber }) => async () => {
  const ok = (s) => s === 200 || s === 304 || s === 404;

  // // Try by UID first
  // if (relatedClaimUid) {
  //   try {
  //     const { data, status } = await axiosInstance.post(
  //       `${process.env.REACT_APP_BACKEND_URL_MS_INSPECTION}/filterInspectionMission`,
  //       { relatedClaimUid },
  //       { validateStatus: ok }
  //     );
  //     if (status === 404) return [];
  //     return Array.isArray(data) ? data : data ? [data] : [];
  //   } catch {
  //     return []; // treat as empty
  //   }
  // }

  // Fallback by claimNumber
  if (claimNumber) {
    try {
      const { data, status } = await axiosInstance.get(
        `${process.env.REACT_APP_BACKEND_URL_MS_INSPECTION}/inspectionMission/getClaimAssociatedMissions/${encodeURIComponent(claimNumber)}`,
        { validateStatus: ok }
      );
      if (status === 404) return [];
      return Array.isArray(data) ? data : data ? [data] : [];
    } catch {
      return [];
    }
  }

  return [];
};



export const createInspectionMission = (mission) => async (dispatch) => {
  try {
    const response = await axiosInstance.post(`${process.env.REACT_APP_BACKEND_URL_MS_INSPECTION}/inspectionMission`, mission);

    return response.data
  } catch (error) {
    dispatch({
      type: 'CREATE_MISSION_FAILURE',
      payload: error.response ? error.response.data : 'Server error',
    });
  }
};

export const createInspectorShiftTimeslot = (inspectorShiftTimeslot) => async (dispatch) => {
  try {
    const response = await axiosInstance.post(`${process.env.REACT_APP_BACKEND_URL_MS_INSPECTION}/inspectorShiftTimeslot/create`, inspectorShiftTimeslot);
    const newInspectorShiftTimeslot = response.data;
    dispatch({
      type: ADD_INSPECTOR_SHIFT_TIMESLOT,
      payload: newInspectorShiftTimeslot,
    });

    return newInspectorShiftTimeslot;
  } catch (error) {
    dispatch({
      type: 'CREATE_INSPECTOR_SHIFT_TIMESLOT',
      payload: error.response ? error.response.data : 'Server error',
    });
  }
};

export const getAllInspectorShiftTimeslot = () => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`${process.env.REACT_APP_BACKEND_URL_MS_INSPECTION}/inspectorShiftTimeslot/getAll`);
    const inspectorShiftTimeslot = response.data;
    const inspectorShiftTimeslotDetails = await Promise.all(inspectorShiftTimeslot.map(async (p) => {
      const repairShopDetails = await getPartyDetails(p.associatedRepairShop);
      const inspectorDetails = await getPartyDetails(p.associatedInspector);
      return { ...p, inspectorDetails, repairShopDetails };
    }));

    dispatch({
      type: GET_ALLINSPECTOR_SHIFT_TIMESLOT,
      payload: inspectorShiftTimeslotDetails,
    });
  } catch (error) {
    dispatch({
      type: GET_ALLINSPECTOR_SHIFT_TIMESLOT_ERROR,
      payload: error.response ? error.response.data : 'Server error',
    });
  }
};
export const filterInspectionMissions = (filters = {}) => async (dispatch) => {
  const convertDateFormat = (date) => {
    const [day, month, year] = date.split('/');
    return `${year}-${month}-${day}`;
  };

  const processedFilters = { ...filters };

  if (processedFilters.missionDate) {
    processedFilters.missionDate = processedFilters.missionDate.map(convertDateFormat);
  }

  try {
    const response = await axiosInstance.post(
      `${process.env.REACT_APP_BACKEND_URL_MS_INSPECTION}/filterInspectionMission`,
      processedFilters
    );
    const filteredMissions = response.data;

    const filteredMissionsDetails = await Promise.all(
      filteredMissions.map(async (p) => {
        const inspectorDetails = await getPartyDetails(p.assignedExpert);

        let garageDetails = null;
        if (p.location) {
          garageDetails = await getPartyDetails(p.location);
          console.log("garageDetails", garageDetails);
        }

        let claimDetails = null;
        if (p.relatedClaimUid) {
          console.log("p.relatedClaimUid", p.relatedClaimUid);
          claimDetails = await dispatch(getClaimDetails(p.relatedClaimUid));
          console.log("claimDetails", claimDetails);
        }

        let goodsDetails = null;
        let registrationCaracteristique = null; // To store the full goodCaracteristique object with "Registration" key
        if (claimDetails && claimDetails.involvedPolicies && claimDetails.involvedPolicies.length > 0) {
          const policyUid = claimDetails.involvedPolicies[0].policyUid; // Assuming the first policy is what you need
          if (policyUid) {
            goodsDetails = await getGoodsForPolicy(policyUid);
            console.log("goodsDetails", goodsDetails);

            // Find the goodCaracteristique where the key is "Registration"
            if (goodsDetails && goodsDetails.length > 0) {
              const goodCaracteristique = goodsDetails[0].goodCaracteristique;
              if (goodCaracteristique && goodCaracteristique.length > 0) {
                registrationCaracteristique = goodCaracteristique.find(item => item.key === "Registration");
                if (registrationCaracteristique) {
                  console.log("Registration Caracteristique:", registrationCaracteristique);
                } else {
                  console.error("No registration key found in goodCaracteristique");
                }
              } else {
                console.error("goodCaracteristique array is empty or undefined");
              }
            }
          } else {
            console.error("policyUid is undefined");
          }
        } else {
          console.error("involvedPolicies array is empty or undefined");
        }

        return {
          ...p,
          inspectorDetails,
          garageDetails,
          claimDetails,
          goodsDetails,
          registrationCaracteristique  // Return the full object with "Registration" key
        };
      })
    );

    dispatch({
      type: FILTER_INSPECTION_MISSIONS,
      payload: filteredMissionsDetails,
    });
  } catch (error) {
    console.error("API Error:", error.response ? error.response.data : 'Server error');
    dispatch({
      type: FILTER_INSPECTION_MISSIONS_ERROR,
      payload: error.response ? error.response.data : 'Server error',
    });
  }
};



export const filterInspectors = (filters) => async (dispatch) => {
  dispatch({ type: FILTER_INSPECTORS_REQUEST });
  try {
    const response = await axiosInstance.post(`${process.env.REACT_APP_BACKEND_URL_MS_INSPECTION}/inspector/filter`, filters);
    const inspectors = response.data;
    const inspectorsWithDetails = await attachPersonDetails(inspectors);
    dispatch({ type: FILTER_INSPECTORS_SUCCESS, payload: inspectorsWithDetails });
    return inspectorsWithDetails
  } catch (error) {
    dispatch({ type: FILTER_INSPECTORS_FAILURE, payload: error.message });
  }
};

export const createInspector = (inspector) => async (dispatch) => {
  try {
    const response = await axiosInstance.post(`${process.env.REACT_APP_BACKEND_URL_MS_INSPECTION}/inspector/create`, inspector);
    const newInspector = response.data;
    dispatch({
      type: 'CREATE_INSPECTOR',
      payload: newInspector,
    });

    return newInspector;
  } catch (error) {
    dispatch({
      type: 'CREATE_INSPECTOR',
      payload: error.response ? error.response.data : 'Server error',
    });
  }
};

export const addCaracteristiqueToInspector = (inspectorId, Caracteristique) => async (dispatch) => {
  try {
    const response = await axiosInstance.post(`${process.env.REACT_APP_BACKEND_URL_MS_INSPECTION}/inspector/addInspectorCaracteristiqueToInspector/${inspectorId}`, Caracteristique);
    const newInspector = response.data;
    dispatch({
      type: 'ADD_INSPECTOR_CARACTERISTIQUE',
      payload: newInspector,
    });

    return newInspector;
  } catch (error) {
    dispatch({
      type: 'ADD_INSPECTOR_CARACTERISTIQUE',
      payload: error.response ? error.response.data : 'Server error',
    });
  }
};

export const deleteInspector = (inspectorId) => {
  return async (dispatch) => {

    try {
      await axiosInstance.delete(`${process.env.REACT_APP_BACKEND_URL_MS_INSPECTION}/inspector/delete/${inspectorId}`);
      dispatch({
        type: 'DELETE_INSPECTOR_SUCCESS',
        payload: inspectorId
      });
    } catch (error) {
      dispatch({
        type: 'DELETE_INSPECTOR_FAILURE',
        payload: error.message
      });
    }
  };
};

export const removeCaracteristiqueFromInspector = (inspectorId, caracteristiqueId) => {
  return async (dispatch) => {

    try {
      let data = {
        "inspectorId": inspectorId,
        "caracteristiqueId": caracteristiqueId
      }
      console.log("data : ", data);
      await axiosInstance.post(`${process.env.REACT_APP_BACKEND_URL_MS_INSPECTION}/inspector/removeCaracteristiqueFromInspector`,
        data);
      dispatch({
        type: 'DELETE_CARACTERISTIQUE_FROM_INSPECTOR_SUCCESS',
        payload: inspectorId
      });
    } catch (error) {
      dispatch({
        type: 'DELETE_CARACTERISTIQUE_FROM_INSPECTOR_FAILURE',
        payload: error.message
      });
    }
  };
};

export async function getInspectionMissionByAssignedExpert(assignedExpert) {
  try {
    const url = `${process.env.REACT_APP_BACKEND_URL_MS_INSPECTION}/inspectionMission/getByAssignedExpert/${assignedExpert}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error(`Error fetching inspection mission details: ${error.message}`);
  }
}

export async function getInspectionMissionByMissionType(missionType) {
  try {
    const url = `${process.env.REACT_APP_BACKEND_URL_MS_INSPECTION}/inspectionMission/getByMissionType/${missionType}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error(`Error fetching inspection mission details: ${error.message}`);
  }
}

export const getInspectorsByGarage = async (garageId) => {
  try {
    const date = new Date();
    const response = await axiosInstance.post(`${process.env.REACT_APP_BACKEND_URL_MS_INSPECTION}/inspectorShiftTimeslot/getByGarage`, {
      associatedRepairShop: garageId,
    });
    return response?.data.inspectorShiftTimeslot;

  } catch (error) {
    console.error('Error fetching inspectors:', error);
    throw error;
  }
};
export const getInspectorsByGarageAndDate = async (garageId) => {
  try {
    const date = new Date();
    const response = await axiosInstance.post(`${process.env.REACT_APP_BACKEND_URL_MS_INSPECTION}/inspectorShiftTimeslot/getByGarageAndDate`, {
      associatedRepairShop: garageId,
      date: date.toISOString().split('T')[0],
    });
    return response?.data.inspectorShiftTimeslot;

  } catch (error) {
    console.error('Error fetching inspectors:', error);
    return null
  }
};
export const fetchInspectorsByAssociatedParty = (associatedParty) => async (dispatch) => {
  try {
    const response = await axiosInstance.post(`${process.env.REACT_APP_BACKEND_URL_MS_INSPECTION}/inspector/filterInspectorsByAssociatedParty`
      , { associatedParty });
    const inspectors = response.data;
    const inspectorsWithDetails = await attachPersonDetails(inspectors);
    dispatch({
      type: FETCH_INSPECTORS_SUCCESS,
      payload: inspectorsWithDetails,
    });
    return inspectorsWithDetails;
  } catch (error) {
    dispatch({
      type: FETCH_INSPECTORS_FAILURE,
      payload: error.message,
    });
    console.error('Error fetching inspectors:', error.message);
  }
};